import { useAppStore } from '@/core/stores/appStore';
import { refreshAdhaCatalogueProfile } from '@/modules/auth/services/adhaCatalogueProfile';
import { useEffect } from 'react';
import { Platform } from 'react-native';

/**
 * Web: after the persisted session loads, refetch GET /v1/customers/profile
 * once per browser load so amenities and derived loan/project fields match
 * the latest response. Native keeps the login snapshot.
 */
export function useRefreshAdhaCatalogueProfile(): void {
  const hasHydrated = useAppStore((state) => state._hasHydrated);
  const isAdhaJourney = useAppStore((state) => state.isAdhaJourney);
  const isAuthenticated = useAppStore((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (Platform.OS !== 'web' || !hasHydrated || !isAdhaJourney || !isAuthenticated) {
      return;
    }
    void refreshAdhaCatalogueProfile();
  }, [hasHydrated, isAdhaJourney, isAuthenticated]);
}
